import { takeLatest, put, call } from 'redux-saga/effects';
import { history, storage } from '@commons';
import {
  createPlantioManejo,
  createPlantioManejoMulti,
  findPlantioManejo,
  updatePlantioManejo,
} from '../service';
import {
  CONFIG_SESSION,
  CREATE_PLANTIO_MANEJO,
  CREATE_PLANTIO_MANEJO_PENDING,
  CREATE_PLANTIO_MANEJO_SUCCESS,
  CREATE_PLANTIO_MANEJO_FAILURE,
  findConversao,
} from '@handler';
import {
  AlertSuccess,
  AlertError,
  AlertWarning,
} from '@components/common/AlertToast';
import {
  formatDateDDMMYYYY,
  formatJsonRemoveEmptyOrNull,
  isDateValidVerifyDateBetween,
} from '@components/common/format';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreatePlantioManejo(action) {
  yield put({ type: CREATE_PLANTIO_MANEJO_PENDING });

  try {
    const safraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva;
    var dateFrom = safraAtiva.dataInicial;
    var dateTo = safraAtiva.dataFinal;
    var dateCheck = action.data.data;

    if (!isDateValidVerifyDateBetween(dateFrom, dateTo, dateCheck)) {
      yield put({ type: CREATE_PLANTIO_MANEJO_FAILURE, registro: action.data });

      AlertWarning('Data informada fora do período da safra ativa. Período deve ser entre '
        + formatDateDDMMYYYY(dateFrom) + ' até ' + formatDateDDMMYYYY(dateTo) + '!');
    } else {
      if (action.data.id === undefined || action.data.id === null) {
        trackingEventCX('action', MODULE_ACTIONS_ENUM.EXECUCAO_ATIVIDADE_CRIAR);
      } else {
        trackingEventCX('action', MODULE_ACTIONS_ENUM.EXECUCAO_ATIVIDADE_EDITAR);
      }

      if (action.data.replicarLancamento) {
        if (action.data.tipoLancamentoTalhao == 'RATEAR') {
          let procedimentosASalvar = [];

          // Calcular a área total de todos os talhões
          let areaTotal = 0;
          for (let i = 0; i < action.data.talhoesList.length; i++) {
            areaTotal += parseFloat(action.data.talhoesList[i].area || 0);
          }

          // Para cada talhão, criar um lançamento com valores proporcionais
          for (let i = 0; i < action.data.talhoesList.length; i++) {
            let talhao = action.data.talhoesList[i];
            let areaTalhao = parseFloat(talhao.area || 0);
            let proporcao = areaTotal > 0 ? areaTalhao / areaTotal : 0;
            
            let procedimentoTalhao = {
              ...action.data,
              'forJson': 'AtivPlantio',
              'sync': false,
              propriedade: {
                id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
              }
            };
            
            procedimentoTalhao.talhao = { ...talhao };
            if (procedimentoTalhao.talhao.talhao !== undefined && procedimentoTalhao.talhao.talhao !== null) {
              procedimentoTalhao.talhao = procedimentoTalhao.talhao.talhao;
            }
            
            // TRATAMENTO DE MAQUINÁRIOS
            procedimentoTalhao.utilizacaoMaquinarios = [];
            procedimentoTalhao.custoTotalMaquinarios = 0;
            
            if (action.data.utilizacaoMaquinarios && action.data.utilizacaoMaquinarios.length > 0) {
              for (let j = 0; j < action.data.utilizacaoMaquinarios.length; j++) {
                let maqOriginal = action.data.utilizacaoMaquinarios[j];
                
                let maqRateado = JSON.parse(JSON.stringify(maqOriginal));
                
                let horasString = maqOriginal.horasQuilometrosTotais || "00:00";
                let [horas, minutos] = horasString.split(":").map(Number);
                let horasTotais = horas + (minutos / 60);
                
                // Calcular horas proporcionais
                let horasProporcionais = horasTotais * proporcao;
                let horasInteiras = Math.floor(horasProporcionais);
                let minutosProporcionais = Math.round((horasProporcionais - horasInteiras) * 60);
                
                maqRateado.horasQuilometrosTotais = 
                  `${horasInteiras.toString().padStart(2, '0')}:${minutosProporcionais.toString().padStart(2, '0')}`;
                
                // Recalcular o custo baseado nas horas proporcionais
                maqRateado.custoTotal = horasProporcionais * parseFloat(maqRateado.custoHoraQuilometro || 0);
                
                procedimentoTalhao.utilizacaoMaquinarios.push(maqRateado);
                procedimentoTalhao.custoTotalMaquinarios += maqRateado.custoTotal;
              }
            }
            
            // TRATAMENTO DE FUNCIONÁRIOS
            procedimentoTalhao.alocacaoFuncionarios = [];
            procedimentoTalhao.custoTotalFuncionarios = 0;
            
            if (action.data.alocacaoFuncionarios && action.data.alocacaoFuncionarios.length > 0) {
              for (let j = 0; j < action.data.alocacaoFuncionarios.length; j++) {
                let funcOriginal = action.data.alocacaoFuncionarios[j];
                
                let funcRateado = JSON.parse(JSON.stringify(funcOriginal));
                
                let horasString = funcOriginal.horasTrabalhadas || "00:00";
                let [horas, minutos] = horasString.split(":").map(Number);
                let horasTotais = horas + (minutos / 60);
                
                // Calcular horas proporcionais
                let horasProporcionais = horasTotais * proporcao;
                let horasInteiras = Math.floor(horasProporcionais);
                let minutosProporcionais = Math.round((horasProporcionais - horasInteiras) * 60);
                
                funcRateado.horasTrabalhadas = 
                  `${horasInteiras.toString().padStart(2, '0')}:${minutosProporcionais.toString().padStart(2, '0')}`;
                
                // Recalcular o custo baseado nas horas proporcionais
                funcRateado.custoTotal = horasProporcionais * parseFloat(funcRateado.custoHomemHora || 0);
                
                procedimentoTalhao.alocacaoFuncionarios.push(funcRateado);
                procedimentoTalhao.custoTotalFuncionarios += funcRateado.custoTotal;
              }
            }
            
            // TRATAMENTO DE INSUMOS (aplicacoes)
            procedimentoTalhao.aplicacoes = [];
            procedimentoTalhao.custoTotalProdutosInsumos = 0;

            if (action.data.aplicacoes && action.data.aplicacoes.length > 0) {
              for (let j = 0; j < action.data.aplicacoes.length; j++) {
                let aplicOriginal = action.data.aplicacoes[j];
                
                let aplicRateada = JSON.parse(JSON.stringify(aplicOriginal));
                
                let formaLanc = '';
                if (!aplicRateada.configLancAgricultura) {
                  formaLanc = safraAtiva.cultura.formaLancPlantio === 'POR_HA' ? 'POR_HA' : 'POR_APLI';
                } else {
                  formaLanc = aplicRateada.configLancAgriculturaTipo === 'POR_HA' ? 'POR_HA' : 'POR_APLI';
                }
                
                // Usar os valores de conversão existentes
                aplicRateada.qtdConversaoAplicacao = aplicOriginal.qtdConversaoAplicacao || 1;
                
                let dosagemOriginal = parseFloat(aplicOriginal.dosagemHa || 0);
                aplicRateada.dosagemHa = dosagemOriginal * proporcao;
                
                // Calcular custos com base na dosagem rateada
                let custoNota = parseFloat(aplicRateada.custoProduto || 0) / aplicRateada.qtdConversaoAplicacao;
                
                if (formaLanc === 'POR_HA') {
                  aplicRateada.custoTotalHa = aplicRateada.dosagemHa * custoNota;
                  aplicRateada.custoTotalTalhao = aplicRateada.custoTotalHa * areaTalhao;
                } else {
                  aplicRateada.custoTotalTalhao = aplicRateada.dosagemHa * custoNota;
                  aplicRateada.custoTotalHa = areaTalhao > 0 ? aplicRateada.custoTotalTalhao / areaTalhao : 0;
                }
                
                // Processar estoque
                aplicRateada.estoqueBaixado = false;
                if (aplicRateada.movimentaEstoque) {
                  aplicRateada.qtdConversaoEstoque = aplicOriginal.qtdConversaoEstoque || 1;
                  
                  if (formaLanc === 'POR_HA') {
                    aplicRateada.estoqueABaixar = aplicRateada.dosagemHa * areaTalhao * aplicRateada.qtdConversaoEstoque;
                  } else {
                    aplicRateada.estoqueABaixar = aplicRateada.dosagemHa * aplicRateada.qtdConversaoEstoque;
                  }
                  
                  if (aplicRateada.informarLocalEstoqueBaixa === false) {
                    aplicRateada.localEstoqueBaixa = null;
                  }
                } else {
                  aplicRateada.estoqueABaixar = 0;
                  aplicRateada.informarLocalEstoqueBaixa = false;
                  aplicRateada.localEstoqueBaixa = null;
                }
                
                aplicRateada.areaTalhao = areaTalhao;
                
                procedimentoTalhao.aplicacoes.push(aplicRateada);
                procedimentoTalhao.custoTotalProdutosInsumos += aplicRateada.custoTotalTalhao;
              }
            }
            
            procedimentosASalvar.push(procedimentoTalhao);
          }

          for (let i = 0; i < procedimentosASalvar.length; i++) {
            delete procedimentosASalvar[i].replicarLancamento;
            delete procedimentosASalvar[i].talhoesList;
            delete procedimentosASalvar[i].tipoLancamentoTalhao;

            // Calcular os custos totais
            procedimentosASalvar[i].custoTotalTalhao = (
              procedimentosASalvar[i].custoTotalProdutosInsumos +
              procedimentosASalvar[i].custoTotalMaquinarios +
              procedimentosASalvar[i].custoTotalFuncionarios
            );

            let areaTalhao = parseFloat(procedimentosASalvar[i].talhao?.area || 0);
            procedimentosASalvar[i].custoTotalHa = areaTalhao > 0 ?
              procedimentosASalvar[i].custoTotalTalhao / areaTalhao : 0;

            // Adiciona os IDs dos controles de praga vinculados
            procedimentosASalvar[i].vinculoControlePragaIds = action.data.controlesVinculados
              ? action.data.controlesVinculados.map(c => c.id)
              : [];

            // Remove campos que não devem ser enviados ao backend
            delete procedimentosASalvar[i].controlesVinculados;
            delete procedimentosASalvar[i].vincularControleFitossanitario;
            delete procedimentosASalvar[i].vinculoControlePraga;
          }

          yield call(createPlantioManejoMulti, procedimentosASalvar);
          yield put({ type: CREATE_PLANTIO_MANEJO_SUCCESS });
          history.push('/agricultura/execucao');
          AlertSuccess('Registro salvo com sucesso!');
        } else {
          let procedimentosASalvar = []

          for (let index = 0; index < action.data.talhoesList.length; index++) {
            let procedimentoTalhao = {
              ...action.data,
              'forJson': 'AtivPlantio',
              'sync': false,
              propriedade: {
                id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
              }
            };
            procedimentoTalhao.talhao = { ...action.data.talhoesList[index] }

            if (procedimentoTalhao.talhao.talhao !== undefined && procedimentoTalhao.talhao.talhao !== null) {
              procedimentoTalhao.talhao = procedimentoTalhao.talhao.talhao;
            }

            procedimentoTalhao.aplicacoes = [...action.data.aplicacoes]

            let custoTotalProdutosInsumos = 0;
            let areaTalhao = action.data.talhoesList[index].area;

            for (let indexAplic = 0; indexAplic < procedimentoTalhao.aplicacoes.length; indexAplic++) {
              let custoTotalHa = 0;
              let custoTotalTalhao = 0;
              let estoqueABaixar = 0;

              let formaLanc = '';
              if (!procedimentoTalhao.aplicacoes[indexAplic].configLancAgricultura) {
                if (safraAtiva.cultura.formaLancPlantio === 'POR_HA') {
                  formaLanc = 'POR_HA';
                } else {
                  formaLanc = 'POR_APLI';
                }
              } else {
                if (procedimentoTalhao.aplicacoes[indexAplic].configLancAgriculturaTipo === 'POR_HA') {
                  formaLanc = 'POR_HA';
                } else {
                  formaLanc = 'POR_APLI';
                }
              }

              procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoAplicacao = 1;
              const conversaoExistente = yield findConversao(procedimentoTalhao.aplicacoes[indexAplic].unidadeCompra, procedimentoTalhao.aplicacoes[indexAplic].unidadeAplicacao);

              if (conversaoExistente) {
                procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoAplicacao = conversaoExistente.qtdConversao;
              } else {
                AlertWarning(`Conversão entre as unidades: ${procedimentoTalhao.aplicacoes[indexAplic].unidadeCompra.descricao} e ${procedimentoTalhao.aplicacoes[indexAplic].unidadeAplicacao.descricao} não configurada. Verifique a conversão para evitar erros no cálculo da aplicação.`)
              }

              if (formaLanc === 'POR_HA') {
                var custoNota = procedimentoTalhao.aplicacoes[indexAplic].custoProduto / procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoAplicacao;
                procedimentoTalhao.aplicacoes[indexAplic].custoTotalHa = procedimentoTalhao.aplicacoes[indexAplic].dosagemHa * custoNota;
                procedimentoTalhao.aplicacoes[indexAplic].custoTotalTalhao = procedimentoTalhao.aplicacoes[indexAplic].custoTotalHa * (areaTalhao ?? 0);
              } else {
                var custoNota = procedimentoTalhao.aplicacoes[indexAplic].custoProduto / procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoAplicacao;
                procedimentoTalhao.aplicacoes[indexAplic].custoTotalTalhao = procedimentoTalhao.aplicacoes[indexAplic].dosagemHa * custoNota;
                procedimentoTalhao.aplicacoes[indexAplic].custoTotalHa = procedimentoTalhao.aplicacoes[indexAplic].custoTotalTalhao / (areaTalhao ?? 0);
              }

              procedimentoTalhao.aplicacoes[indexAplic].estoqueBaixado = false;
              if (procedimentoTalhao.aplicacoes[indexAplic].movimentaEstoque) {
                procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoEstoque = 1;
                const conversaoExistente = yield findConversao(procedimentoTalhao.aplicacoes[indexAplic].unidadeAplicacao, procedimentoTalhao.aplicacoes[indexAplic].unidadeEstoque);

                if (conversaoExistente) {
                  procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoEstoque = conversaoExistente.qtdConversao;
                } else {
                  AlertWarning(`Conversão entre as unidades: ${procedimentoTalhao.aplicacoes[indexAplic].unidadeAplicacao.descricao} e ${procedimentoTalhao.aplicacoes[indexAplic].unidadeEstoque.descricao} não configurada. Verifique a conversão para evitar erros na entrada do estoque da nota.`)
                }
                if (formaLanc === 'POR_HA') {
                  procedimentoTalhao.aplicacoes[indexAplic].estoqueABaixar = procedimentoTalhao.aplicacoes[indexAplic].dosagemHa * (areaTalhao ?? 0) * procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoEstoque;
                } else {
                  procedimentoTalhao.aplicacoes[indexAplic].estoqueABaixar = procedimentoTalhao.aplicacoes[indexAplic].dosagemHa * procedimentoTalhao.aplicacoes[indexAplic].qtdConversaoEstoque;
                }
                if (procedimentoTalhao.aplicacoes[indexAplic].informarLocalEstoqueBaixa === false) {
                  procedimentoTalhao.aplicacoes[indexAplic].localEstoqueBaixa = null;
                }
              } else {
                procedimentoTalhao.aplicacoes[indexAplic].estoqueABaixar = 0;
                procedimentoTalhao.aplicacoes[indexAplic].informarLocalEstoqueBaixa = false;
                procedimentoTalhao.aplicacoes[indexAplic].localEstoqueBaixa = null;
              }

              procedimentoTalhao.aplicacoes[indexAplic] = {
                ...procedimentoTalhao.aplicacoes[indexAplic],
                areaTalhao: areaTalhao,
              }

              custoTotalProdutosInsumos += custoTotalTalhao;
            }
            procedimentoTalhao.custoTotalProdutosInsumos = custoTotalProdutosInsumos;

            procedimentosASalvar.push(procedimentoTalhao)
          }

          for (let index = 0; index < procedimentosASalvar.length; index++) {
            delete procedimentosASalvar[index].replicarLancamento;
            delete procedimentosASalvar[index].talhoesList;

            procedimentosASalvar[index].custoTotalTalhao = (procedimentosASalvar[index].custoTotalProdutosInsumos + procedimentosASalvar[index].custoTotalMaquinarios + procedimentosASalvar[index].custoTotalFuncionarios);
            procedimentosASalvar[index].custoTotalHa = (procedimentosASalvar[index].custoTotalTalhao / (procedimentosASalvar[index].talhao?.area ?? 0));

            // Adiciona os IDs dos controles de praga vinculados
            procedimentosASalvar[index].vinculoControlePragaIds = action.data.controlesVinculados
              ? action.data.controlesVinculados.map(c => c.id)
              : [];

            // Remove campos que não devem ser enviados ao backend
            delete procedimentosASalvar[index].controlesVinculados;
            delete procedimentosASalvar[index].vincularControleFitossanitario;
            delete procedimentosASalvar[index].vinculoControlePraga;
          }

          yield call(createPlantioManejoMulti, procedimentosASalvar);

          yield put({ type: CREATE_PLANTIO_MANEJO_SUCCESS });

          history.push('/agricultura/execucao');

          AlertSuccess('Registro salvo com sucesso!');
        }
      } else {
        var idAplicacao;

        if (action.data.talhao.talhao !== undefined && action.data.talhao.talhao !== null) {
          action.data.talhao = action.data.talhao.talhao;
        }

        delete action.data.replicarLancamento;
        delete action.data.talhoesList;

        // Extrai os IDs dos controles de praga vinculados
        const vinculoControlePragaIds = action.data.controlesVinculados
          ? action.data.controlesVinculados.map(c => c.id)
          : [];

        // Remove campos que não devem ser enviados ao backend
        delete action.data.controlesVinculados;
        delete action.data.vincularControleFitossanitario;
        delete action.data.vinculoControlePraga;

        if (action.data.id === undefined || action.data.id === null) {
          var saved = yield call(createPlantioManejo, formatJsonRemoveEmptyOrNull({
            ...action.data,
            'forJson': 'AtivPlantio',
            'sync': false,
            propriedade: {
              id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
            },
            vinculoControlePragaIds,
          }));
          idAplicacao = saved.data.id;
        } else {
          idAplicacao = action.data.id;
          yield call(updatePlantioManejo,
            {
              ...action.data,
              id: action.data.id,
              vinculoControlePragaIds,
            }
          );
        }

        yield put({ type: CREATE_PLANTIO_MANEJO_SUCCESS, registro: action.data });

        if (action.redirecionaPaginaPlanejamento !== undefined && action.redirecionaPaginaPlanejamento !== null && action.redirecionaPaginaPlanejamento) {
          history.push('/agricultura/planejamento');
        } else {
          history.push('/agricultura/execucao');
        }

        AlertSuccess('Registro salvo com sucesso!');

        const novoRegistro = yield call(findPlantioManejo, idAplicacao);
        if (novoRegistro.possuiPendenciaEstoque) {
          AlertWarning('Estoque não processado por falta de insumos. Verifique a aplicação...');
        }
      }
    }
  } catch (error) {
    yield put({ type: CREATE_PLANTIO_MANEJO_FAILURE, registro: action.data });

    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreatePlantioManejo() {
  yield takeLatest(CREATE_PLANTIO_MANEJO, sagaCreatePlantioManejo);
}
